import { render, staticRenderFns } from "./CustomFieldBoolean.vue?vue&type=template&id=33929954&scoped=true"
import script from "./CustomFieldBoolean.vue?vue&type=script&lang=ts"
export * from "./CustomFieldBoolean.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldBoolean.vue?vue&type=style&index=0&id=33929954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33929954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCheckbox,VProgressLinear})
